.checkBoxContainer {
  width: 100%;
  box-sizing: border-box;
  display: flex;
  justify-self: start;
  align-items: center;

  .svgClass {
    display: flex;
    width: 8px;
    height: 6px;
    opacity: 0;
    transition: opacity 0.25s ease-out;
    transform: scale(1.5);

    &.checkedSvg {
      transition: opacity 0.25s ease-in;
      opacity: 1;
      display: flex;
    }
  }

  .checkBoxText {
    margin: 0;
    &.disableUserSelect {
      user-select: none;
    }
  }

  .checkBoxInput {
    display: none;
  }

  &.extra-small {
    column-gap: 5px;

    .svgClass {
      transform: scale(0.5);
    }
  }

  &.small {
    column-gap: 6px;
  }

  &.default {
    column-gap: 10px;
  }

  &.medium {
    column-gap: 6px;

    .svgClass {
      transform: scale(1.25);
    }
  }

  &.large {
    column-gap: 10px;

    .svgClass {
      transform: scale(1.25);
    }
  }

  &.extra-large {
    column-gap: 10px;

    .svgClass {
      transform: scale(1.5);
    }
  }

  .noBorder {
    border: none;
  }

  .icon {
    position: absolute;
    top: 50%;
    transform: translate(0, -50%);
    left: 12px;
    cursor: pointer;
    font-size: inherit;
  }

  .withIcon {
    padding-left: 36px;
  }

  .clearIcon {
    position: absolute;
    top: 50%;
    transform: translate(0, -50%);
    right: 24px;
    cursor: pointer;
    display: none;

    &.active {
      display: block;
    }
  }

  .StyledCheckbox {
    display: flex;
    align-items: center;
    justify-content: center;
    transition: background-color 0.25s ease-out, border-color 0.25s ease-out;
    cursor: pointer;

    &.br- {
      border-radius: 6px;
    }
  }

  .styledCheckboxCheck {
    display: flex;
    align-items: center;
    justify-content: center;
    transition: background-color 0.25s ease-in, border-color 0.25s ease-in;
  }
}

.textEllipsis {
  overflow: hidden;
  p {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
}
